module.exports = __webpack_public_path__ + "static/Roof Tile Cleaning-23a02ec3f43438826ff9e86364a3cb90.jpg";